import { FETCH_SUBSCRIBER_FAIL, FETCH_SUBSCRIBER_SUCCESS } from '@actions/types'

const initialState = {
  emails: [],
  firstname: '',
  groups: [],
  isLoading: true,
  lastname: '',
  sms: [],
  username: '',
  voice: []
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case FETCH_SUBSCRIBER_FAIL:
    return {
      ...state,
      isLoading: false
    }
  case FETCH_SUBSCRIBER_SUCCESS:
    return {
      ...state,
      ...payload.data,
      isLoading: false
    }
  default:
    return state
  }
}

export default reducer
